import { render, staticRenderFns } from "./AboutStats.vue?vue&type=template&id=707f257e&"
import script from "./AboutStats.vue?vue&type=script&lang=ts&"
export * from "./AboutStats.vue?vue&type=script&lang=ts&"
import style0 from "./AboutStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports